import {SagaIterator} from "redux-saga";
import {all, takeLatest} from "redux-saga/effects";
import {
	fetchBETime,
	fetchChecksumsJSON,
	fetchFAQJson,
	fetchHelpPageJsons,
	fetchHelpPagesJson,
	userFetch,
	globalError,
	userLogin,
	userLogout,
	userRegister,
	userUpdate,
	saveShare,
	fetchLeagues,
	createLeague,
	inviteToLeague,
	fetchLeaguesForJoin,
	joinLeague,
	leaveLeague,
	fetchLeagueRankings,
	fetchLeagueUsers,
	removeUser,
	updateLeague,
	fetchLeaderboard,
	userRegisterAllFields,
	fetchRounds,
	fetchSquads,
	fetchLeagueForJoin,
	userRegisterApp,
	userLoginApp,
	userRegisterAllFieldsApp,
	requestPlayers,
	requestSinglePlayerStats,
	fetchCountries,
	fetchGotcLeague,
	userBackdoorLogin,
	fetchTranslatedCountries,
	fetchAchievementsCount,
	fetchSettings, fetchUserLevel,
} from "modules/actions";
import {errorsManagerSaga} from "modules/sagas/errors";
import {
	fetchChecksumsJSONSaga,
	fetchCountriesSaga,
	fetchFAQJSONSaga,
	fetchHelpPageJsonsSaga,
	fetchHelpPagesJSONSaga,
	fetchSettingsSaga,
	fetchTranslatedCountriesSaga,
} from "modules/sagas/json";
import {fetchBackEndTimeSaga} from "modules/sagas/time";
import {
	userBackdoorLoginSaga,
	userFetchSaga,
	userLoginAppSaga,
	userLoginSaga,
	userLogoutSaga,
	userRegisterAllFieldsAppSaga,
	userRegisterAllFieldsSaga,
	userRegisterAppSaga,
	userRegisterSaga,
	userUpdateSaga,
} from "modules/sagas/user";
import {saveShareSaga} from "modules/sagas/share";
import {
	createLeagueSaga,
	fetchGotcLeagueSaga,
	fetchLeagueForJoinSaga,
	fetchLeagueRankingsSaga,
	fetchLeaguesForJoinSaga,
	fetchLeaguesSaga,
	fetchLeagueUsersSaga,
	inviteToLeagueSaga,
	joinLeagueSaga,
	leaveLeagueSaga,
	removeUserSaga,
	updateLeagueSaga,
} from "modules/sagas/leagues";
import {fetchLeaderboardSaga} from "modules/sagas/leaderboard";

import {fetchRoundsSaga} from "./rounds";
import {fetchSquadsSaga} from "./squads";
import {requestPlayersSaga, requestSinglePlayerStatsSaga} from "./players";
import {requestGamezoneBaner, requestGamezoneLevel} from "./gamezone_baner";

/**
 * Root saga that connect sagas with actions.
 */
export const rootSaga = function* (): SagaIterator {
	yield all([
		/**
		 * JSON
		 */
		takeLatest(fetchChecksumsJSON, fetchChecksumsJSONSaga),
		takeLatest(fetchHelpPagesJson, fetchHelpPagesJSONSaga),
		takeLatest(fetchFAQJson, fetchFAQJSONSaga),
		takeLatest(fetchHelpPageJsons, fetchHelpPageJsonsSaga),
		takeLatest(fetchCountries, fetchCountriesSaga),
		takeLatest(fetchTranslatedCountries, fetchTranslatedCountriesSaga),
		takeLatest(fetchSettings, fetchSettingsSaga),

		/**
		 * Players
		 */
		takeLatest(requestPlayers, requestPlayersSaga),
		takeLatest(requestSinglePlayerStats, requestSinglePlayerStatsSaga),

		/**
		 * Rounds
		 */
		takeLatest(fetchRounds, fetchRoundsSaga),

		/**
		 * Squads
		 */
		takeLatest(fetchSquads, fetchSquadsSaga),

		/**
		 * Common
		 */
		takeLatest(globalError, errorsManagerSaga),
		takeLatest(fetchBETime, fetchBackEndTimeSaga),

		/**
		 * Share
		 */
		takeLatest(saveShare, saveShareSaga),

		/**
		 * Auth
		 */
		takeLatest(userRegister, userRegisterSaga),
		takeLatest(userRegisterApp, userRegisterAppSaga),
		takeLatest(userRegisterAllFields, userRegisterAllFieldsSaga),
		takeLatest(userRegisterAllFieldsApp, userRegisterAllFieldsAppSaga),
		takeLatest(userBackdoorLogin, userBackdoorLoginSaga),
		takeLatest(userLogin, userLoginSaga),
		takeLatest(userLoginApp, userLoginAppSaga),
		takeLatest(userLogout, userLogoutSaga),

		/**
		 * User
		 */
		takeLatest(userFetch, userFetchSaga),
		takeLatest(userUpdate, userUpdateSaga),

		/**
		 * Game
		 */

		/**
		 * Contact
		 */

		/**
		 * Rankings
		 */
		takeLatest(fetchLeaderboard, fetchLeaderboardSaga),

		/**
		 * Leagues
		 */
		takeLatest(fetchLeagues, fetchLeaguesSaga),
		takeLatest(createLeague, createLeagueSaga),
		takeLatest(updateLeague, updateLeagueSaga),
		takeLatest(inviteToLeague, inviteToLeagueSaga),
		takeLatest(fetchLeaguesForJoin, fetchLeaguesForJoinSaga),
		takeLatest(joinLeague, joinLeagueSaga),
		takeLatest(leaveLeague, leaveLeagueSaga),
		takeLatest(fetchLeagueRankings, fetchLeagueRankingsSaga),
		takeLatest(fetchLeagueUsers, fetchLeagueUsersSaga),
		takeLatest(removeUser, removeUserSaga),
		takeLatest(fetchLeagueForJoin, fetchLeagueForJoinSaga),
		takeLatest(fetchGotcLeague, fetchGotcLeagueSaga),

		/**
		 * Game zone
		 */
		takeLatest(fetchAchievementsCount, requestGamezoneBaner),
		takeLatest(fetchUserLevel, requestGamezoneLevel),
	]);
};

export * from "./errors";
export * from "./json";
export * from "./time";
export * from "./rounds";
export * from "./players";
